import { Routes } from '@angular/router';
import { PageComponent } from './page/page.component';
import { ContactFormComponent } from './contact-form/contact-form.component';

export const CMSPAGE_ROUTES: Routes = [
  {path: 'page/:slug', component: PageComponent},
  {path: 'contact', component: ContactFormComponent}
];
